import { Container, Image } from "react-bootstrap";

export default function AppLoader() {
	return (
		<Container fluid className="d-flex align-items-center justify-content-center" style={{ minHeight: "100dvh" }}>
			<Image src={process.env.PUBLIC_URL + "/von_meeting_logo_on_white.svg"} />
		</Container>
	);
}
